import React,{useEffect,useState,Fragment} from 'react';
import ciudadesJSON from './municipios.json'
import Button from 'react-bootstrap-button-loader';
import { toast } from 'react-toastify'; 
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Switch from '@material-ui/core/Switch'

const Detalle = (props) => {

    const [datos, setDatos] = useState({
        puesto:'',
        estado:'',
        ciudad:'',
        descripcion:'',
        escolaridad:'',
        edad:'',
        genero:'',
        cualidades:'',
        requerimientos:'',
        actividades:'',
        sueldos:'',
        visible:true
    });

    const [modal2, setModal2] = useState();
    const [ciudades, setCiudades] = useState([]);
    const [look, setLook] = useState(false);
    const [ID, setID] = useState(props.pag_actualizar);

    useEffect(() => {
        // console.log(ID);
        if(ID!=0){
            fetch('/p_bolsa', { 
                method: 'PATCH', 
                body: JSON.stringify({ID}), 
                headers: {'Content-Type': 'application/json'} 
            })
            .then(res => res.json())
            .then(res => {
                // console.log(res);
                setCiudades(ciudadesJSON[res.ESTADO])
                setDatos({
                    puesto: res.PUESTO,
                    estado: res.ESTADO,
                    ciudad: res.CIUDAD,
                    descripcion: res.DESCRIPCION,
                    escolaridad: res.ESCOLARIDAD,
                    edad: res.EDAD,
                    genero: res.GENERO,
                    cualidades: res.CUALIDADES,
                    requerimientos: res.REQUERIMIENTOS,
                    actividades: res.ACTIVIDADES_A_REALIZAR,
                    sueldos: res.SUELDOS_Y_PRESTACIONES,
                    visible: res.VISIBLE
                })
            })
        }
    }, [ID]);

    const toggle2 = () => setModal2(!modal2)

    const changeBolsa=(e)=>{
        ([e.target.name]=='estado' && [e.target.value]!='') && setCiudades(ciudadesJSON[e.target.value])
        setDatos({ ...datos, [e.target.name] : e.target.value})
    }

    const agregarBolsa=()=>{
        const {puesto, estado, ciudad, descripcion, escolaridad, edad, genero, cualidades, requerimientos, actividades, sueldos} = datos
        if(puesto!='' && estado!='' && ciudad!='' && descripcion!='' && escolaridad!='' && edad!='' && genero!='' && cualidades!='' && requerimientos!='' && actividades!='' && sueldos){
            setLook(true)
            fetch('/p_bolsa', { 
                method: 'POST', 
                body: JSON.stringify({datos}), 
                headers: {'Content-Type': 'application/json'} 
            })
            .then(res => res.json())
            .then(res => {
                // console.log(res);
                if(res.RESULT==1){
                    toast.success(`Se ha agregado correctamente.`,{ position: toast.POSITION.BOTTOM_RIGHT });
                    props.setPag_actualizar(-1)
                }
                
            })
            .catch(err => console.log('Error: '+err))
        }
        else{
            toast.warn(`Tienes elementos vacíos.`,{ position: toast.POSITION.BOTTOM_RIGHT });
        }
    }

    const actualizarBolsa=()=>{
        const {puesto, estado, ciudad, descripcion, escolaridad, edad, genero, cualidades, requerimientos, actividades, sueldos} = datos
        if(puesto!='' && estado!='' && ciudad!='' && descripcion!='' && escolaridad!='' && edad!='' && genero!='' && cualidades!='' && requerimientos!='' && actividades!='' && sueldos){
            setLook(true)
            fetch('/p_bolsa', { 
                method: 'PUT', 
                body: JSON.stringify({ID, ...datos}), 
                headers: {'Content-Type': 'application/json'} 
            })
            .then(res => res.json())
            .then(res => {
                toast.success(`Se ha actualizado correctamente.`,{ position: toast.POSITION.BOTTOM_RIGHT });
                props.setPag_actualizar(-1)
            })
            .catch(err => console.log('Error: '+err))
        }
        else{
            toast.warn(`Tienes elementos vacíos.`,{ position: toast.POSITION.BOTTOM_RIGHT });
        }
    }

    const eliminarBolsa=()=>{
        setLook(true)
        fetch('/p_bolsa', { 
            method: 'DELETE', 
            body: JSON.stringify({ID}), 
            headers: {'Content-Type': 'application/json'} 
        })
        .then(res => res.json())
        .then(res => {
            if(res.RESULT==1){
                toast.success(`Se ha eliminado correctamente.`,{ position: toast.POSITION.BOTTOM_RIGHT });
                props.setPag_actualizar(-1)
            }
            
        })
        .catch(err => console.log('Error: '+err))
    }

    return (
        <Fragment>
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-body">
                        <button className="btn btn-outline-light-2x txt-dark mb-4" onClick={()=> props.setPag_actualizar(-1)}>
                            <i className="icofont icofont-arrow-left"/>Regresar
                        </button>
                        <div className="row d-flex justify-content-center">
                            <h3>{props.pag_actualizar == 0 ? 'Agregar':'Actualizar'} Bolsa de Trabajo</h3>
                        </div>
                        <div className="row">
                            <Fragment>
                                <div className="col-sm-12 col-md-12">
							        <div className="form-group">
								        <label className={`form-label`}>Puesto</label>
								        <input name={`puesto`} value={datos.puesto}  className={`form-control`} type="text" autoComplete="off" onChange={changeBolsa}/>
							        </div>
                                </div>
                                <div className="col-sm-12 col-md-12">
                                    <div className="form-group">
								        <label className={`form-label`}>Descripción</label>
								        <textarea style={{minHeight:'100px'}} name={`descripcion`} value={datos.descripcion} className={`form-control`} type="text" autoComplete="off" onChange={changeBolsa}/>
							        </div>
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <div className="form-group">
								        <label className={`form-label`}>Estado</label>
                                        <select className="form-control" name="estado" placeholder="Estado..." value={datos.estado} onChange={changeBolsa} >
                                            <option value="" disabled>Seleccione un Estado</option>
                                            <option value="TAMAULIPAS">Tamaulipas</option>
                                            <option value="VERACRUZ">Veracruz</option>
                                            <option value="PUEBLA">Puebla</option>
                                            <option value="HIDALGO">Hidalgo</option>
                                            <option value="SAN LUIS POTOSI">San Luis Potosí</option>
                                        </select>
								    </div>
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <div className="form-group">
								        <label className={`form-label`}>Ciudad</label>
								        <select className="form-control" name="ciudad" placeholder="Ciudad..." value={datos.ciudad} onChange={changeBolsa} >
                                            <option value="">Seleccione una Ciudad</option>
                                            {ciudades.map(x=><option key={x} value={x}>{x}</option>)}
                                        </select>
							        </div>
                                </div>
                                <div className="col-sm-12 col-md-4">
                                    <div className="form-group">
								        <label className={`form-label`}>Escolaridad</label>
								        <input name={`escolaridad`} value={datos.escolaridad} className={`form-control`} type="text" autoComplete="off" onChange={changeBolsa}/>
							        </div>
                                </div>
                                <div className="col-sm-12 col-md-4">
                                    <div className="form-group">
								        <label className={`form-label`}>Edad (Min - Max)</label>
								        <input name={`edad`} value={datos.edad} className={`form-control`} type="text" autoComplete="off" onChange={changeBolsa}/>
							        </div>
                                </div>
                                <div className="col-sm-12 col-md-4">
                                    <div className="form-group">
								        <label className={`form-label`}>Género</label>
								        <select className="form-control" name="genero" placeholder="Género..." value={datos.genero} onChange={changeBolsa} >
                                            <option value="" disabled>Seleccione un Género</option>
                                            <option value="Masculino">Masculino</option>
                                            <option value="Femenino">Femenino</option>
                                            <option value="Indistinto">Indistinto</option>
                                        </select>
							        </div>
                                </div>
                                <div className="col-sm-12 col-md-12">
                                    <div className="form-group">
								        <label className={`form-label`}>Cualidades</label>
								        <textarea name={`cualidades`} style={{minHeight:'100px'}} value={datos.cualidades} className={`form-control`} type="text" autoComplete="off" onChange={changeBolsa}/>
							        </div>
                                </div>
                                <div className="col-sm-12 col-md-12">
                                    <div className="form-group">
								        <label className={`form-label`}>Requerimientos</label>
								        <textarea name={`requerimientos`} style={{minHeight:'100px'}} value={datos.requerimientos} className={`form-control`} type="text" autoComplete="off" onChange={changeBolsa}/>
							        </div>
                                </div>
                                <div className="col-sm-12 col-md-12">
                                    <div className="form-group">
								        <label className={`form-label`}>Actividades a realizar</label>
								        <textarea name={`actividades`} style={{minHeight:'100px'}} value={datos.actividades} className={`form-control`} type="text" autoComplete="off" onChange={changeBolsa}/>
							        </div>
                                </div>
                                <div className="col-sm-12 col-md-12">
                                    <div className="form-group">
								        <label className={`form-label`}>Sueldos y prestaciones</label>
								        <textarea name={`sueldos`} style={{minHeight:'100px'}} value={datos.sueldos} className={`form-control`} type="text" autoComplete="off" onChange={changeBolsa}/>
							        </div>
						        </div>
                                <div className="col-sm-12 col-md-12">
                                    <div className="form-group mt-4 text-center shadow shadow-showcase p-1">
							        	<label className={`form-label mb-0`}>Visible:</label>
							        	<Switch color="primary" onChange={()=>setDatos({...datos,'visible':!datos.visible})} checked={datos.visible} />
							        	<label className={`form-label`}>{datos.visible?'Si':'No'}</label>
							        </div>
						        </div>
                                <div className="col-md-12 mt-2 d-flex justify-content-between">
                                    {
                                        props.pag_actualizar !=0 && 
                                        <div className="text-left">
						            		<button className='btn btn-danger btn-lg ml-4' type="button" onClick={toggle2}>Borrar <i className="icon-trash" aria-hidden="true"></i></button>
                                        </div>
                                    }
                                    <div className="text-right">
                                        <Button className='btn-lg mr-4' disabled={look} onClick={()=>{props.pag_actualizar == 0 ? agregarBolsa() : actualizarBolsa()}}>Guardar</Button>
                                    </div>
                                </div>
                            </Fragment>
                        </div>
                    </div>
                </div>
            </div>
            <Modal isOpen={modal2} toggle={toggle2} className="modal-body" centered={true}>
                <ModalHeader toggle={toggle2}>Eliminar</ModalHeader>
                <ModalBody>
                    ¿Está seguro que desea eliminar?
                </ModalBody>
                <ModalFooter>
                    <Button className="btn-danger" onClick={eliminarBolsa} disabled={look}><i className="icofont icofont-trash" />Eliminar</Button>
                    <Button color="secondary" onClick={toggle2}>Cancelar</Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}
 
export default Detalle;